import { render, staticRenderFns } from "./CreateUAMUser.vue?vue&type=template&id=5c6ff299"
import script from "./CreateUAMUser.vue?vue&type=script&lang=js"
export * from "./CreateUAMUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports